import React from 'react'

const ButtonLoader = () => {
    return (
        <div className="loading-indicator">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
        </div>
    )
}

export default ButtonLoader